<template>
  <div class="row">
    <div class="col-lg-8 m-auto">
      <card title="Verificar Correo Electrónico">
        <template v-if="success">
          <div class="alert alert-success" role="alert">
            {{ success }}
          </div>

          <router-link :to="{ name: 'login' }" class="btn btn-primary">
            Iniciar Sesión
          </router-link>
        </template>
        <template v-else>
          <div class="alert alert-danger" role="alert">
            {{ error }}
          </div>

          <router-link :to="{ name: 'verification.resend' }" class="small float-right">
            Reenviar enlace de verificación
          </router-link>
        </template>
      </card>
    </div>
  </div>
</template>

<script>
const qs = (params) => Object.keys(params).map((key) => `${key}=${params[key]}`).join('&');

export default {
  middleware: 'guest',

  metaInfo() {
    return { title: 'Verificar Correo Electrónico' };
  },

  async beforeRouteEnter(to, from, next) {
    try {
      const { data } = await window.axios.post(`/api/email/verify/${to.params.id}?${qs(to.query)}`);

      next((vm) => { vm.success = data.status; });
    } catch (e) {
      next((vm) => { vm.error = e.response.data.status; });
    }
  },

  data: () => ({
    error: '',
    success: '',
  }),
};
</script>
